import {AddPersonalisedItem, AddPersonalisedItemCallback, AddPersonalisedItemContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const addPersonalisedItemESB = new AddPersonalisedItem()
const AddPersonalisedItemCallbackESB = new AddPersonalisedItemCallback()

class AddPersonalisedItemApiModel {
    data: object
}

const SendApiRequest = (url: string, data: AddPersonalisedItemContractModel) => {
    const apiModel = new AddPersonalisedItemApiModel()

    const [firstItem] = data?.data?.items || []
    apiModel.data = firstItem

    const {itemId, articleTarget, option, chain, isPersonalised, personalisedGiftTheme} = data.data

    ShoppingBagApiPost(
        {data: JSON.stringify(apiModel.data)},
        `${url}/personalisecallbackv2?itemid=${itemId}&articletarget=${articleTarget}&option=${option}&chain=${chain}&ispersonalised=${isPersonalised}&personalisedgifttheme=${personalisedGiftTheme}`,
        AddPersonalisedItemCallbackESB,
        data.eventId,
        "formData",
    )
}

export const SubscribeToShoppingBagAddPersonalisedItem = (siteUrl: string) => {
    addPersonalisedItemESB.subscribe(data => {
        SendApiRequest(siteUrl, data)
    })
}
